import { defineStore } from "pinia";

export const useEvaluationInterviewStore = defineStore('evaluationInterview', {
    state: () => ({
        evaluationInterview: {},
        evaluationInterviews: [],
        refresh: null,
    }),
    actions: {
        setRefresh() {
            const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let randomString = '';
            for (let i = 0; i < 10; i++) {
                const randomIndex = Math.floor(Math.random() * charset.length);
                randomString += charset[randomIndex];
            }
            this.refresh = randomString;
        },
        setEvaluationInterview(evaluationInterview) {
            this.evaluationInterview = evaluationInterview
        },
        setEvaluationInterviews(evaluationInterviews) {
            this.evaluationInterviews = evaluationInterviews
        },
        addEvaluationInterview(evaluationInterview) {
            this.evaluationInterviews.unshift(evaluationInterview)
        },
        updateEvaluationInterview(evaluationInterview) {
            let index = this.evaluationInterviews.findIndex(cl => cl.id === evaluationInterview.id)
            this.evaluationInterviews.splice(index, 1, evaluationInterview)
        },
        deleteEvaluationInterview(evaluationInterview) {
            let index = this.evaluationInterviews.findIndex(cl => cl.id === evaluationInterview.id)
            this.evaluationInterviews.splice(index, 1)
        },
    },
});